export default "__VITE_ASSET__DXYo_rYI__"